/* Tells the sticky chrome whether it is pinned.
 *
 * A sentinel one pixel tall sits immediately above the chrome. While it intersects the viewport the
 * page is scrolled to the top; the moment it leaves, the chrome is holding position over content and
 * earns its shadow. One observer, no scroll handler, no work on the scroll thread.
 */
const sentinel = document.querySelector('.chrome-sentinel')
const chrome = document.querySelector('.shopify-section-group-header-group')

if (sentinel && chrome && 'IntersectionObserver' in window) {
  new IntersectionObserver(
    ([entry]) => chrome.toggleAttribute('data-stuck', !entry.isIntersecting),
    { threshold: 0 },
  ).observe(sentinel)
}


/* ---------------------------------------------------------------- chrome height

   Anything that sticks BELOW the chrome has to know how tall the chrome is. That height is not a
   constant: the header row wraps on narrow screens and the sub-aisle strip only renders inside a
   department, so it measured 121px, 168px and 230px on the same store. `.rail` had a hardcoded
   `top: 8.5rem` (136px), which was wrong at every one of them — parking the rail either under the
   header or 60px below where it should sit.

   A custom property can only be set from script, so the chrome publishes its own height and every
   sticky consumer reads it. ResizeObserver, not a resize listener: it fires for the sub-rail
   appearing on a department page too, which a viewport listener would miss entirely. */
if (chrome && 'ResizeObserver' in window) {
  const publish = () => {
    document.documentElement.style.setProperty('--chrome-h', `${Math.round(chrome.getBoundingClientRect().height)}px`)
  }
  new ResizeObserver(publish).observe(chrome)
  publish()
}


/* ---------------------------------------------------------------- image arrival

   The plate shimmers while an image is in flight and must stop the moment it lands. `complete` is
   checked as well as the load event, because an image served from cache can finish before this
   module runs and would otherwise shimmer forever underneath a fully painted product. */
const markLoaded = (img) => img.setAttribute('data-loaded', '')
for (const img of document.querySelectorAll('.tile__media img, .aisletile__media img')) {
  if (img.complete) markLoaded(img)
  else {
    img.addEventListener('load', () => markLoaded(img), { once: true })
    // A broken image must stop the shimmer too, or the plate advertises loading forever for
    // something that is never going to arrive.
    img.addEventListener('error', () => markLoaded(img), { once: true })
  }
}

/* iOS Safari does not fire :active on an element unless the document carries a touch listener.
   The press contract exists FOR touch, so without this it is dead on the one platform it targets. */
document.addEventListener('touchstart', () => {}, { passive: true })
